import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/blog.scss";

const Blog = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="blog-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="blog-page__main">
        <div className="blog-container">
          <h1 className="blog-title">Blog</h1>
          
          <div className="blog-empty-state">
            <div className="empty-icon-wrapper">
              <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="empty-box-icon">
                <path d="M12 24L32 16L52 24L32 32L12 24Z" />
                <path d="M12 24V40L32 48L52 40V24" />
                <path d="M32 32V48" />
                <path d="M22 8L26 14" />
                <path d="M42 8L38 14" />
                <path d="M32 4V10" />
              </svg>
            </div>
            <p className="empty-text">No Blog</p>
            
            <button className="back-btn" onClick={handleBack}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              BACK
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
